import { Controller } from "@hotwired/stimulus"
import { openPersonaChatPane } from "../utils/persona_pane"

// Mounted on the persona hero's picture area. Today it only handles the
// "Video" hover pill. The video pipeline itself is real (Assistant::Tools::
// PersonaAnimate -> Media::VideoJob), but chat is its deliberate, documented
// v1 entry point (see that file's header comment) — there is no persona-sheet
// form endpoint that posts into it directly the way portraits do. So this
// opens the Jane chat pane and pre-types the request rather than submitting
// anything itself — the same thing the settings copy already tells users to
// type themselves ("Ask Jane in chat for 'a video of yourself…'").
export default class extends Controller {
    promptVideo() {
        openPersonaChatPane()
        this._prefill("Make a video of yourself")
    }

    // Reading offsetParent forces layout, so this correctly sees the pane
    // switch above even though it just happened in the same tick.
    _prefill(text) {
        let fields = Array.from(document.querySelectorAll(".assistant-compose-field"))
        let field = fields.find((el) => el.offsetParent !== null) || fields[0]
        if (!field) return
        field.value = text
        field.dispatchEvent(new Event("input", { bubbles: true }))
        field.focus()
    }
}
